module.exports = __webpack_public_path__ + "static/Winner seal__NSW_Best Finance Broker-8acfc391c90853cc94c1be561c831449.png";